export default {
  expenseAppeal: 'Merchant Expense Appeal',
  mallExpenseAppealList: 'Mall Expense Appeal List',
  logisticsExpenseAppeal: 'Logistics Expense Appeal List',
  payExpenseAppeal: 'Payment Expense Appeal List',
  payExpenseAppealList: 'Mall Payment Appeal List',
  expenseDetail: 'Expense Appeal Details',
  businessNo: 'Business Reference ID',
  billingNo: 'Fee ID',
  appealType: 'Appeal Type',
  mallSku: 'Mall SKU',
  selectTime: 'Select Time Range',
  appealSubmitTime: 'Appeal Submission Time',
  businessReviewTime: 'Business Review Time',
  fromDate: 'Start Date',
  toDate: 'End Date',
  exportExcel: 'Export to Excel',
  appealNo: 'Appeal Order ID',
  billingRecordNo: 'Fee ID',
  currency: 'Currency',
  originalAmount: 'Original Amount',
  appealAmount: 'Appeal Amount',
  type: 'Type',
  belongBusiness: 'Business Segment',
  relatedBusinessNo: 'Related Business ID',
  generatedTime: 'Creation Time',
  status: 'Status',
  settlementCompletedTime: 'Settled Time',
  operation: 'Operations',
  details: 'Details',
  cancel: 'Cancel',
  exportSuccess: 'Export Successful',
  exportFailed: 'Export Failed or No Data',
  appealTypeSelect: 'Appeal Type',
  orderNo: 'Appeal Order ID',
  exportExcelFile: 'Export to Excel',
  exportFileName: 'Logistics Expense Appeal Management',
  expenseAppealDetails: 'Expense Appeal Details',
  paymentAppealDetails: 'Payment Appeal Details',
  mallAppealDetails: 'Mall Appeal Details',
  logisticsAppealDetails: 'Logistics Appeal Details',
  appealInfo: 'Appeal Information',
  feeType: 'Fee Type',
  businessType: 'Business Type',
  originalFeeAmount: 'Original Fee Amount',
  appealRemark: 'Appeal Remarks',
  appealTime: 'Appeal Time',
  appealMaterials: 'Appeal Attachments',
  businessAuditInfo: 'Business Audit Information',
  businessAuditRemark: 'Audit Remarks',
  businessApprovedAmount: 'Business Approved Amount',
  financeAuditInfo: 'Finance Audit Information',
  financeAuditRemark: 'Audit Remarks',
  financeApprovedAmount: 'Finance Approved Amount',
  auditInfo: 'Audit Records',
  rejectionInfo: 'Rejection Info',
  rejectionReason: 'Rejection Reason',
  approvedAmount: 'Approved Amount',
  originalFeeAndDocInfo: 'Original Fee & Document Info',
  feeAmount: 'Fee Amount',
  billingTime: 'Billing Time',
  feeDescription: 'Fee Description',
  feeRemark: 'Fee Remark',
  objectId: 'Object ID',
  objectType: 'Object Type',
  authorizationProgress: 'Processing Progress & Actions',
  associatedBillingNo: 'Associated (New Generated) Billing No.',
  cancelAppeal: 'Cancel Appeal',
  edit: 'Edit',
  editAppeal: 'Edit Appeal',
  submitted: 'Approved',
  rejected: 'Rejected',
  confirmed: 'Confirmed',
  completed: 'Completed',
  cancelled: 'Cancelled',
  getAppealTypeListFailed: 'Failed to Get Appeal Type List',
  getAppealListFailed: 'Failed to Get Appeal List',
  cancelAppealFailed: 'Cancel Failed',
  operationFailed: 'Operation Failed',
  appealAmountPlaceholder: 'Appeal Amount',
  appealDetailTitle: 'Appeal Details',
  getDetailFailed: 'Failed to Get Details',
  approved: 'Approved',
  cancelSuccess: 'Cancel Successful',
  editSuccess: 'Edit Successful',
  editFailed: 'Edit Failed',
  inputAppealAmount: 'Please Enter Appeal Amount',
  confirm: 'Confirm',
  logisticsAppealDetailTitle: 'Logistics Appeal Details',
  // Appeal Status for list filter
  all: 'All',
  pendingBusinessReview: 'Pending Business Review',
  pendingFinancialAudit: 'Pending Financial Audit',
  pendingSettlement: 'Pending Settlement',
  pendingReview: 'Pending Review',
  editAppealSuccess: 'Edit Appeal Successful',
  editAppealFailed: 'Edit Appeal Failed',
  appeal: 'Appeal',
  merchantExpenseAppeal: 'Merchant Expense Appeal',
  feeInfo: 'Fee Information',
  feeBlock: 'Fee Block',
  selectFeeBlock: 'Please Select Fee Block',
  feeItem: 'Fee Item',
  selectFeeType: 'Please Select Fee Type',
  billingRecordId: 'Fee Id',
  inputBillingRecordId: 'Please Enter Fee Id',
  feeSubject: 'Fee/Subject',
  amount: 'Amount',
  feeRelatedInfo: 'Fee Related Information',
  feeRecordTime: 'Fee Record Time',
  feeStatus: 'Fee Status',
  appealStatus: 'Appeal Status Flow',
  approvedFee: 'Approved Fee',
  businessAuditTime: 'Business Audit Time',
  financeAuditTime: 'Finance Audit Time',
  settlementTime: 'Settled Time',
  noFeeTypeInBlock: 'No Fee Type in This Fee Block',
  getFeeTypeFailed: 'Failed to Get Fee Type',
  regionCodeMissing: 'RegionCode Parameter Missing',
  queryFeeInfoSuccess: 'Fee Information Query Successful',
  queryFailed: 'Query Failed',
  appealCreateSuccess: 'Appeal Created Successfully',
  appealCreateFailed: 'Failed to Create Appeal',
  queryFeeInfoFirst: 'Please query fee info first',
  appealAmountTooLarge: 'Appeal amount cannot be greater than the fee amount',
  appealAmountExceedLimit: 'Appeal amount cannot exceed 2000',
  appealAmountExceedFeeAmount: 'Appeal amount cannot exceed the fee amount',
  appealAmountExceedProductAmount: 'Appeal amount cannot exceed the product amount',
  // Appeal steps
  stepSubmitAppeal: 'Appeal Submitted',
  stepBusinessReview: 'Business Audit',
  stepFinanceReview: 'Financial Audit',
  stepSettlement: 'Settlement',
  stepCompleted: 'Completed',
  stepCancelled: 'Cancelled',
  stepRejected: 'Rejected',
  // Confirm actions
  confirmEdit: 'Confirm to submit?',
  confirmCancelAppeal: 'Confirm to cancel the appeal?',
  // Button text
  btnConfirm: 'Confirm',
  btnCancel: 'Cancel',
  // Tips
  tips: 'Warm Tips',
  appealUpdateSuccess: 'Appeal Updated Successfully',
  appealUpdateFailed: 'Failed to Update Appeal',
  fetchDetailFailed: 'Failed to Fetch Details',
  // Fee Status
  feeStatusCreated: 'Created',
  feeStatusConfirmed: 'Confirmed',
  feeStatusBilled: 'Pending Settlement',
  feeStatusSettled: 'Settled',
  feeStatusRefused: 'Refused',
  storeId: 'Store#',
  fundAccount: 'Settlement Account No.'
}
